



















































import Vue from 'vue'
import { DATASETS_STATUSES as statuses } from '@/config/constants'

export default Vue.extend({
  name: 'DatasetStatus',
  props: {
    status: {
      type: String,
      default: statuses.inProgress,
      required: true
    },
    onClickStatus: {
      type: Function,
      default: () => {}
    }
  },
  data: () => ({
    statuses
  })
})
